import areaServiceStore from './areaServiceStore';

export default {
  install(store) {
    if (!store.state.base) {
      store.registerModule(['base'], {
        state: {},
      });
    }
    if (!store.state.base.areaServiceOption) {
      store.registerModule(['base', 'areaServiceOption'], areaServiceStore);
    }
  },
  uninstall(store) {
    store.unregisterModule(['base', 'areaServiceOption']);
  },
};
